import React, { useState,useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import LoginIcon from './create_novel_illustration.svg'
import { FloatingInput } from '../../../../components/FormComponents'
import { get, post } from '../../../../lib/api'
import { menuItemObj } from '../../../../components/PrivatePage'
import { Text, Button } from '../../../../designSystem'
import { checkOverseasUser, handleEventLog, handlePageLoadEventLog } from '../../../../lib/utils'
import { convertCanvasToImage } from '../NovelForm/novelCoverImg'
import VideoPlayer from '../../../../components/VideoPlayer'
import { isMobileOrTablet, getModuleOrTextAccordingToLocale } from '../../../Home/helpers'
import { AccountContext } from '../../../../providers/accountProvider'
import {
  Wrapper,
  ErrorMessage,
  Container,
  LeftDiv,
  MainDiv,
  RightDiv
} from './styles'


const contestReferrer = window.location.href.includes('contest') || localStorage.getItem('referrer')?.includes('contest')
export const blobToFile = theBlob => new File([theBlob], 'untitled.png', { lastModified: new Date().getTime(),  type: theBlob.type})

export const getImageUrl = async (bookName,referrer, isUgcUser) =>{
  const authorName = localStorage.getItem('name')
  if (!authorName) {
    throw new Error('author name missing')
  }
  const url = await convertCanvasToImage(bookName,authorName)
  const blob = await fetch(url).then(r => r.blob())
  const coverFile = blobToFile(blob)
  await uploadFile(coverFile,bookName,referrer,isUgcUser)
}

export const uploadFile = (file,bookName,referrer, isUgcUser) => {
  const fileNameSplit = file.name.split('.')
    const ext = fileNameSplit.length > 1 ? fileNameSplit.pop() : ''
    const params = {
      tags:  'image',
      image_extension: ext,
      title: bookName,
      is_novel: 1
    }
    const getPreSignedUrl = '/upload/get_presigned_url'
    get(getPreSignedUrl, {params}).then(response => {
      const imageUrl = response.result[0]
      const awsFields = imageUrl.fields
      const suffix = imageUrl.s3_unique_key
      const formData = new FormData()
      formData.append('key', awsFields.key)
      formData.append('AWSAccessKeyId', awsFields.AWSAccessKeyId)
      formData.append('x-amz-security-token', awsFields['x-amz-security-token'])
      formData.append('policy', awsFields.policy)
      formData.append('signature', awsFields.signature)
      formData.append('file', file);
      const prefix = imageUrl.url
      const cdn = 'https://djhonz7dexnot.cloudfront.net'
      post(prefix, {data: formData,}).then(response => {
        const data={
          book_title: bookName,
          image_url: `${cdn}/${suffix}`,
          view: 'writers'
        }
        if(referrer==='premyatra')
          data.contest_data={contest_id:"f7b3efb413092fcb4b56ceab7324628f88aca614",entity_type:'novel'};
        if(isUgcUser){
          data.language = 'english'
        }
        post(`/content_api/book.create_book?is_novel=${isUgcUser ? 2 : 1}`, { data: data }).then(response => {
          const { book_id, is_novel } = response.results
          if(contestReferrer){
            const books = localStorage.getItem('contestBooks') || []
            const list = [...books,book_id]
            localStorage.setItem('contestBooks',JSON.stringify(list))
          }
          if(is_novel === 2){
            const { image_url, created_by, description, description_en, editor_score, tags } = response.results
            const showData = {
              'created_by': created_by,
              'uid': created_by,
              'show_title': bookName,
              'show_desc': description,
              'show_desc_en': description_en,
              'language': 'english',
              'editor_score': editor_score,
              'is_disabled': 0,
              'image_url': image_url,
              'author_id': created_by,
              'sort_order': 'asc',
              'series': 1,
              "data_source": "writers"
            }
            post(`/content_api/show.create?is_novel=0`,{data : showData}).then((res) => {
              const { show_id } = res.result[0].show_info
              post(`/content_api/book.associate_book_and_show?is_novel=1`, {
                data : {
                  show_id,
                  book_id,
                  created_by,
                  tags
                }
              }).then(() => {
                window.location.assign(`${menuItemObj.novels}/edit-novel-details/${book_id}?proceed_to_chapter=1`)
              })
            })
          }else{
            window.location.assign(`${menuItemObj.novels}/add-chapter/${book_id}?proceed_to_details=1&novel_creation_flow=1`)
          }
          
          // if(book_id) {
          //   if(isUgcUser){
          //     window.location.assign(`${menuItemObj.novels}/edit-novel-details/${book_id}?proceed_to_chapter=1`)
          //   }else{
          //     window.location.assign(`${menuItemObj.novels}/add-chapter/${book_id}?proceed_to_details=1&novel_creation_flow=1`)
          //   }
          // }
        })
      })
    })
}

const CreateNew = ({history, isHome}) => {
  const [bookName, updateBookName] = useState('')
  const [isBookNameInvalid, setIsBookNameInvalid] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isBookCreateProcessing, setIsBookCreateProcessing] = useState(false)
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const referrer = params.get("referrer");
  const { user, isUgcUser} = useContext(AccountContext)
  const isUserFromIndia = !checkOverseasUser(user)
  useEffect(() => {
    handlePageLoadEventLog('create_new_novel')
  },[])

  const handleBookNameInputChange = text => {
    if(isBookNameInvalid) {
      setIsBookNameInvalid(false)
      setErrorMessage("")
    }
    updateBookName(text)
  }

  const checkTitleValidOrNot = () => {
    if(isBookCreateProcessing) return
    if(!bookName || bookName.trim().length === 0) {
      setIsBookNameInvalid(true)
      setErrorMessage("Enter title")
      return
    }
    if(bookName.trim().length > 70){
      setIsBookNameInvalid(true)
      setErrorMessage("Title shouldn't be more than 70 characters")
      return
    }
    setIsBookNameInvalid(false)
    setIsBookCreateProcessing(true)
    if(isUgcUser){
      get(`/search/novel_search/similar_titles/?query=${bookName}&is_novel=1`).then((res) =>{
        if(res?.results?.length){
          setIsBookCreateProcessing(false)
          setIsBookNameInvalid(true)
          setErrorMessage("Sorry, we have series with similar name")
        }else{
          handleBookCreate()
        }
      })
    }else{
      handleBookCreate()
    }
  }


  const handleBookCreate = async () => {
    handleEventLog('create_new_novel','button_click',{route : window.location.pathname + window.location.search,button:'create_book'})
    getImageUrl(bookName.trim(),referrer,isUgcUser)
  }
  let CreateCtaText = '';
  if(contestReferrer){
    CreateCtaText = 'Your Novel will be a part of Contest and also eligible for Writer Benefit program'
  }else {
    CreateCtaText = 'Your Novel will be a part of Writer Benefit program'
  }
  const tabFilterOnLanguageBasis = ['hindi', 'tamil', 'english'].includes(user.languages);
  if(!tabFilterOnLanguageBasis || !isUserFromIndia){
    CreateCtaText = 'Start Your Journey'
  }

  return (
    <Wrapper isHome={isHome}>
      <Container>
          <MainDiv isHome={isHome} isMobile={isMobileOrTablet()}>
            <LeftDiv isUgcUser={isUgcUser} userLanguages={user?.languages || ""}>
              {(user?.languages === "hindi"  || isUgcUser) ?
               (<VideoPlayer 
                videoSrc={getModuleOrTextAccordingToLocale(user,'videoTutorialSrc')} 
                videoType="video/mp4"
                />)
                :
              (<div>
                <img src={LoginIcon} alt=""/>
              </div>)
              }
            </LeftDiv>
            <RightDiv isHome={isHome}>
                <Text variant="titleMedium" mb={16}>
                  {getModuleOrTextAccordingToLocale(user,contestReferrer ? 'createContestNewNovelHeading' : 'createNewNovelHeading')}
                </Text>

                <Text variant="titleSecondary" fontWeight="r" mb={24}>
                  {CreateCtaText}
                </Text>

                <FloatingInput
                  type="text"
                  name="book-name"
                  value={bookName}
                  label={getModuleOrTextAccordingToLocale(user,'label')}
                  height="48px"
                  padding="4px 8px"
                  fontSize="12px"
                  onChange={text => handleBookNameInputChange(text)}
                />
                {isBookNameInvalid && <ErrorMessage>{errorMessage}</ErrorMessage>}
                {/* <CreateBookButton onClick={handleBookCreate} disabled={!bookName}>
                    {isBookCreateProcessing ? <Loader size='sm' invertColor noPadding /> : 'Create Book and Go to First Chapter'}
                </CreateBookButton> */}
                <Button sizeVariant="M" variant="fillPrimary" mt={8} isLoading={isBookCreateProcessing} width="100%" onClick={checkTitleValidOrNot} disabled={!bookName}>
                  {getModuleOrTextAccordingToLocale(user,contestReferrer ? 'contestCreateNovelCTAText' : 'createNewNovelCTAText')}
                </Button>
            </RightDiv>
          </MainDiv>
      </Container>
    </Wrapper>
  )
}

export default withRouter(CreateNew)
